export default __webpack_public_path__ + "static/CondensedRegular-f04f3ab2b94a45ff5a958a65cab93d93.woff2";